import { defineMessages } from 'react-intl';

const messages: {
	menuItemLoading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	menuItemLoading: {
		id: 'navigation.universal-create.menuItemLoading',
		defaultMessage: 'Menu item is loading',
		description: 'The message that screen reader announces when a menu item is loading',
	},
});

export default messages;
